import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description PensionSavings icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { PensionSavings } from '@sravni/design-system-icons'
 *
 * <PensionSavings />
 * ```
 */
var PensionSavings = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "PensionSavings", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.164 11V4a1 1 0 0 1 1-1h9.572a1 1 0 0 1 1 1v12.786a1 1 0 0 1-1 1H7.163a1 1 0 0 1-1-1V16", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M14.445 12.715h1.256m-7.256 0H9.99m-7.255 0H3.99M6.165 11a2.32 2.32 0 0 1 2.357 2.357 2.304 2.304 0 0 1-2.357 2.25 2.289 2.289 0 0 1-2.25-2.25A2.304 2.304 0 0 1 6.165 11Zm6 0a2.32 2.32 0 0 1 2.358 2.357 2.304 2.304 0 0 1-2.357 2.25 2.289 2.289 0 0 1-2.25-2.25A2.304 2.304 0 0 1 12.166 11ZM9.236 6h6m-3.5 2h3.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { PensionSavings };
//# sourceMappingURL=PensionSavings.js.map
